/* Akoya – gemeinsames, sanftes Parallax fuer mehrere Sections.
   Elemente mit [data-akoya-parallax="<px>"] innerhalb eines Elements
   mit der Klasse .akoya-parallax-scope bewegen sich beim Scrollen
   unterschiedlich schnell. Auf breiteren Screens (ab 1000px) faellt
   der Versatz staerker aus.

   Wichtig: Je nach Browser/Geraet scrollt entweder das Fenster selbst
   oder ein innerer Container (.page-wrapper, wegen der aktivierten
   Seitenuebergaenge – Safari/Chrome/Mobile verhalten sich hier
   unterschiedlich). Die Positionsberechnung (getBoundingClientRect)
   ist ohnehin immer viewport-relativ und damit unabhaengig davon.
   Nur das "wann neu berechnen" muss robust sein: wir lauschen per
   Capture-Phase auf window, das faengt Scroll-Events aus jedem
   inneren Container ab, egal welcher es gerade ist. */

(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  var scopes = Array.prototype.slice.call(document.querySelectorAll('.akoya-parallax-scope'));
  if (!scopes.length) return;

  var desktopQuery = window.matchMedia('(min-width: 1000px)');
  var DESKTOP_MULTIPLIER = 1.75;

  var active = new Set();
  var ticking = false;

  function apply(scope) {
    var rect = scope.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var center = rect.top + rect.height / 2;
    var progress = (vh / 2 - center) / (vh / 2 + rect.height / 2);
    progress = Math.max(-1, Math.min(1, progress));

    var multiplier = desktopQuery.matches ? DESKTOP_MULTIPLIER : 1;

    var targets = scope.querySelectorAll('[data-akoya-parallax]');
    targets.forEach(function (el) {
      var amount = (parseFloat(el.getAttribute('data-akoya-parallax')) || 0) * multiplier;
      el.style.transform = 'translateY(' + (progress * amount).toFixed(1) + 'px)';
    });
  }

  function update() {
    active.forEach(apply);
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            active.add(entry.target);
          } else {
            active.delete(entry.target);
          }
        });
        onScroll();
      },
      { rootMargin: '20% 0px 20% 0px' }
    );
    scopes.forEach(function (scope) {
      observer.observe(scope);
    });
  } else {
    scopes.forEach(function (scope) {
      active.add(scope);
    });
  }

  // Capture-Phase: faengt 'scroll' von window UND von jedem inneren
  // scrollenden Container ab (z.B. .page-wrapper), unabhaengig davon,
  // welches Element auf dem jeweiligen Geraet tatsaechlich scrollt.
  window.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll);
  onScroll();
})();
